import React from 'react';
import annotationIcon from '../../icons/annotation.svg';
import SVGIcon from '../../components/SVGIcon';
import styles from './AnnotationIcon.module.scss';

const AnnotationIcon = () => (
  <div className={styles.container}>
    <SVGIcon>{annotationIcon}</SVGIcon>
  </div>
);

export default AnnotationIcon;
